import { render, staticRenderFns } from "./AreaAnswer.vue?vue&type=template&id=3f8209d8&scoped=true"
import script from "./AreaAnswer.vue?vue&type=script&lang=js"
export * from "./AreaAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8209d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f8209d8')) {
      api.createRecord('3f8209d8', component.options)
    } else {
      api.reload('3f8209d8', component.options)
    }
    module.hot.accept("./AreaAnswer.vue?vue&type=template&id=3f8209d8&scoped=true", function () {
      api.rerender('3f8209d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/five/instrument/disabilityEvaluationQuestionnaire/components/AreaAnswer.vue"
export default component.exports